import {Injectable} from '@angular/core';
import {apiEndpoints} from '../../app.constants';
import {BackendHttpService} from '../../core/backend-http.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class ReferenceDataService extends BackendHttpService<any> {

  private definitions: any;

  public loadDefinitions(): Observable<any> {
    return this.get(apiEndpoints.definitions);
  }

  updateDefinitionsData(definition) {
    this.definitions = definition;
  }

  get verticals() {
    return this.definitions.verticals;
  }

  get topics() {
    return this.definitions.topics;
  }

  get activeTopics() {
    if (!this.definitions) {
      return [];
    }
    return this.definitions.topics.filter(t => t.isHidden === 0);
  }

  get platforms() {
    return this.definitions ? this.definitions.platforms : [];
  }

  get countries() {
    return this.definitions ? this.definitions.countries : [];
  }

  get languages() {
    return this.definitions ? this.definitions.languages : [];
  }

  get network() {
    return this.definitions.network;
  }

  get type() {
    return this.definitions.type;
  }

  get referenceData() {
    return this.definitions;
  }

  get channelTypes() {
    return this.definitions.channelTypes;
  }

  get campaignTypes() {
    return this.definitions.campaignTypes;
  }

  get mixPanelToken() {
    return this.definitions.mixPanelToken;
  }

  get accountTypes() {
    return this.definitions.accountTypes;
  }

  public getLanguageByCountry(country): Observable<any> {
    return this.get(apiEndpoints.getLanguageByCountry, {
      country_id: country
    }).map(res => res.data);
  }

  public loadDismissReasons(): Observable<any> {
    return this.get(apiEndpoints.getDismissReasons).map(res => {
      const data = res.data;
      return data.map(d => ({
        id: d.id,
        name: d.dismissReasonsName
      }));
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/reference-data/reference-data.service.ts